import { render, staticRenderFns } from "./RelatorioTemplate.vue?vue&type=template&id=377f1d14"
import script from "./RelatorioTemplate.vue?vue&type=script&lang=js"
export * from "./RelatorioTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports